import React from "react";
import { Image as KonvaImage, Group, Arrow } from "react-konva";
import useImage from "use-image";

const PlayerArrow = ({ x, y, rotation, id, onDragMove, onDragStart, onDragEnd, name, src = "/icons/BlueArrowIcon.png", size = 40, draggable = true, onContextMenu, strokeColor = 'red' }) => {
  const [image] = useImage(src);
  const handleDragMove = (e) => onDragMove && onDragMove(id, e.target.x(), e.target.y());
  const handleContext = (e) => {
    e.evt && e.evt.preventDefault && e.evt.preventDefault();
    if (onContextMenu) onContextMenu(id, e);
  };

  // Try to infer a default color for the fallback arrow from the filename
  const fallbackColor = src && src.toLowerCase().includes("red") ? "#c00" : "#0a6";

  // Use Group so rotation/drag are applied around group's origin
  return (
    <Group
      name={name}
      x={x}
      y={y}
      rotation={rotation}
      draggable={draggable}
      onDragStart={() => onDragStart && onDragStart(id)}
      onDragMove={handleDragMove}
      onDragEnd={(e) => onDragEnd && onDragEnd(id, e.target.x(), e.target.y())}
      onContextMenu={handleContext}
    >
      {image ? (
        <KonvaImage
          image={image}
          width={size}
          height={size}
          offset={{ x: size / 2, y: size / 2 }} // center the image
          stroke={strokeColor}
          strokeWidth={1}
          listening // ensures pointer events work
        />
      ) : (
        <Arrow
          points={[0, 0, size * 0.6, 0]}
          pointerLength={size * 0.25}
          pointerWidth={size * 0.25}
          fill={fallbackColor}
          stroke={fallbackColor}
          strokeWidth={Math.max(2, size * 0.08)}
        />
      )}
    </Group>
  );
};

export default PlayerArrow;